import { registerComponent } from '@gig/magic-common';
import CollapsibleRowComponent from './collapsible-row.vue.js';

var CollapsibleRow = registerComponent(CollapsibleRowComponent);

export { CollapsibleRow };
